export interface Layout2ColProps {
    /** JSX content for the left column */
    left?: React.ReactNode
    /** JSX content for the right column */
    right?: React.ReactNode
    /** Hides the left column on sm screens */
    hideLeft?: boolean
}

/**
 * 2 Col layout which will stack on small screens. Use hideLeft boolean to hide
 * the left side on small screens
 */
export function Layout2Col({ left, right, hideLeft = false }: Layout2ColProps) {
    const leftClasses = hideLeft ? 'hidden  h-screen md:block' : ''

    return (
        <main className='md:grid md:grid-cols-2 h-screen'>
            <section
                className={` ${leftClasses} bg-black text-white px-6 py-6 md:px-12 md:py-12`}>
                {left}
            </section>
            <section className={`h-screen py-0 px-6 md:px-12`}>{right}</section>
        </main>
    )
}
